import * as React from "react";
import { useTheme } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import SwipeableViews from "react-swipeable-views";
import { autoPlay } from "react-swipeable-views-utils";
import imgone from "../../../assets/OfferingBanner.png";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
  position: {
    position: "absolute !important",
    textAlign: "left !important",
    width: "45vw !important",
    color: "#white !important",
    fontSize: "2.3vw !important",
    fontWeight: "600 !important",
    color: "white !important",
    lineHeight: "3vw !important",

    margin: theme.spacing("15vw", "0vw", "2vw", "7vw"),
    fontFamily: "Raleway !important",
  },
  position1: {
    textAlign: "left !important",
    width: "45vw!important",
    position: "absolute !important",
    fontSize: "1.5vw !important",
    fontWeight: "510 !important",

    margin: theme.spacing("22vw", "0vw", "3vw", "7vw"),
    fontFamily: "Raleway !important",
    lineHeight: "2vw !important",
  },
  position2: {
    textAlign: "left !important",
    width: "27vw !important",
    position: "absolute !important",
    fontSize: "1.5vw !important",
    margin: theme.spacing("27vw", "0vw", "2vw", "7vw"),
    fontFamily: "Raleway !important",
    lineHeight: "2vw !important",
  },
}));

const AutoPlaySwipeableViews = autoPlay(SwipeableViews);

const images = [
  {
    imgPath: imgone,
    text: "Assurance by NanoHealth is addressing the gaps in healthcare.",
    text1: "One-stop destination for a healthier you.",
  },
];

const LandingPage = () => {
  const classes = useStyles();
  const theme = useTheme();
  const [activeStep, setActiveStep] = React.useState(0);

  const handleStepChange = (step) => {
    setActiveStep(step);
  };

  return (
    <div>
      <Box sx={{ maxWidth: "100%", flexGrow: 1 }}>
        <Paper
          square
          elevation={1}
          sx={{
            display: "flex",
            alignItems: "center",
            pl: 1,
          }}
        >
          <Typography>{images[activeStep].label}</Typography>
        </Paper>
        <AutoPlaySwipeableViews
          axis={theme.direction === "rtl" ? "x-reverse" : "x"}
          index={activeStep}
          onChangeIndex={handleStepChange}
          enableMouseEvents
        >
          {images.map((step, index) => (
            <div key={step.label}>
              <h2 className={classes.position}> {step.text}</h2>
              <p className={classes.position1}> {step.text1}</p>
              <p className={classes.position2}> {step.text2}</p>

              {Math.abs(activeStep - index) <= 2 ? (
                <Box
                  component="img"
                  sx={{
                    display: "block",
                    overflow: "hidden",
                    width: "100%",
                    animation: "fade 2s linear",
                  }}
                  src={step.imgPath}
                  alt={step.label}
                />
              ) : null}
            </div>
          ))}
        </AutoPlaySwipeableViews>
      </Box>
    </div>
  );
};

export default LandingPage;
